import { sameArray, camelCase, isType, clone } from './utils';
import { getChart } from './getChart';
const utils = {
    sameArray,
    camelCase,
    isType,
    clone,
};
export { utils, getChart };
